import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle, Divider,
  Drawer, IconButton, Alert,Stack, Chip
} from '@mui/material';
import SubdirectoryArrowRightIcon from '@mui/icons-material/SubdirectoryArrowRight';
import { InfoOutlineRounded } from '@mui/icons-material';
import ScheduleDialog from '../pages/ScheduleDialog';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import UploadIcon from "@mui/icons-material/Upload";
import DownloadIcon from "@mui/icons-material/Download";
import RowActionMenu from "../components/RowActionMenu";
import CloseIcon from "@mui/icons-material/Close";

import FileCopyOutlinedIcon from "@mui/icons-material/FileCopyOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import PowerSettingsNewOutlinedIcon from "@mui/icons-material/PowerSettingsNewOutlined";
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import { useNavigate, useLocation } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { DataGrid } from '@mui/x-data-grid';
import Layout from '../layout/layout';
import { api } from '../services/api';
import { useToast } from "../components/ToastContext";
import CircularProgress from '@mui/material/CircularProgress';
import SearchComponent from '../components/Search';
import ApplicationNameDetails from '../pages/ApplicationNameDetails';

import { motion } from 'framer-motion';
import ResourceStatusDialog from '../components/ResourceDialog';
import RefreshIcon from "@mui/icons-material/Refresh";
import Tooltip from "@mui/material/Tooltip";
import { evaluateAndReturn } from '../Utils/common';
import { useConfig } from "../../src/services/ConfigContext";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CircleIcon from '@mui/icons-material/Circle';
import RoleGuard from "../components/RoleGuard";
import { hasPermission } from '../Utils/role';

const Resource = () => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  const toast = useToast();
  const navigate = useNavigate();
  const [resources, setResources] = useState([]);
  const [filteredResources, setFilteredResources] = useState([]);
   const [searchText, setSearchText] = useState('');
  const [debouncedSearchText, setDebouncedSearchText] = useState('');
  const [totalCount, setTotalCount] = useState(0);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 20,
  });
  const location = useLocation();
  const { resourceName } = location.state || {};
  const { resourceId } = location.state || {};
  const [loading, setLoading] = useState(false);
  const [selectedStatuses, setSelectedStatuses] = useState([ ]);
  const bulkStartStop = hasPermission('BULK_START_STOP');
  const handleStatusToggle = (statusKey) => {
  setSelectedStatuses((prev) =>
    prev.includes(statusKey)
      ? prev.filter((s) => s !== statusKey)
      : [...prev, statusKey]
  );
};
  const [, setApprovalSettings] = useState(null);
  const [statusDialogOpen, setStatusDialogOpen] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [expandedRows, setExpandedRows] = useState({});
  const catalogueSelection = localStorage.getItem('catalogueSelection');
  const isCreateDisabled = catalogueSelection === 'Operational';
  const [resourceTypeId, setResourceTypeId] = useState(null);
  const [scheduleDialogOpen, setScheduleDialogOpen] = useState(false);
  const [scheduleAction, setScheduleAction] = useState(null); // 'start' or 'stop'
  const [selectedResourceForAction, setSelectedResourceForAction] = useState(null);
  const [actionDialogOpen, setActionDialogOpen] = useState(false);
  const [selectedResource, setSelectedResource] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [dialogLoading, setDialogLoading] = useState(false);
  const [currentInstanceStates, setCurrentInstanceState] = useState([]);
  const [actionLoading, setActionLoading] = useState(false);
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [pendingAction, setPendingAction] = useState(null); // 'start' or 'stop'
  const {config} = useConfig();
  const isBulkAction = config?.isBulkAction;
  const isUploadDownloadTag = config?.isUploadDownloadTag;
  const [isBulkTagPopupOpen, setIsBulkTagPopupOpen] = useState(false);
  const rawUserId = sessionStorage.getItem("userId");
  const currentUserId = rawUserId ? parseInt(rawUserId, 10) : "";
  const allowedBulkTagResources = ["ec2", "security groups", "s3 bucket"];
  const isBulkTagAllowed = resourceName && allowedBulkTagResources.includes(resourceName.toLowerCase());
  const instanceColumns = [
    { field: "applicationName", headerName: "Application", flex: 1 },
    { field: "resourceNameConstraint", headerName: "Resource Name", flex: 1 },
    { field: "awsInstanceId", headerName: "Instance ID", flex: 1 },
    {
      field: "state",
      headerName: "Status",
      flex: 0.8,
      renderCell: (params) => {
        const status = (params.value ?? "notfound").toLowerCase();

        const color =
          runningIndicatorColors[status] || "#6B7280";

        return (
          <Box sx={{ display: "flex", alignItems: "center", gap: 1, height: '100%' }}>
            {/* Status dot */}
            <Box
              sx={{
                width: 8,
                height: 8,
                borderRadius: "50%",
              }}
            />

            <Typography
              variant="body2"
              sx={{ textTransform: status !== "notfound" ? "capitalize" : "none" }}
            >
              {status === "notfound" ? "Not found" : status}
            </Typography>
          </Box>
        );
      },
    }
  ];

  const LogicMonitorButton = ({ instanceId }) => {
  const [isLoading, setIsLoading] = useState(false);
  const toast = useToast();

 const handleRedirect = async (e) => {
    e.stopPropagation(); 
    setIsLoading(true);

    try {
      const correlationId = crypto.randomUUID();
      const response = await api.get(`/api/LogicMonitor/LMResourceURL/${instanceId}`, {
        headers: { 'X-CORRELATION-ID': correlationId }
      });

      if (response.data && response.data.treeNodesUrl) {
        const newTab = window.open(response.data.treeNodesUrl, '_blank');
        
        if (!newTab) {
          toast.error("Pop-up blocked! Please allow pop-ups for this site to view Logic Monitor.");
        }
      } else {
        const apiMessage = response.data?.message || (typeof response.data === 'string' ? response.data : null);
        toast.error(apiMessage || "Logic Monitor Tree Nodes URL not found for this instance.");
      }
    } catch (error) {
      console.error("Error fetching Logic Monitor URL:", error);
      
      const errorMsg = error.response?.data?.message || (typeof error.response?.data === 'string' ? error.response?.data : null);
      
      toast.error(errorMsg || "Failed to connect to Logic Monitor API.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Tooltip title="Check status in Logic Monitor" arrow placement="top">
      <IconButton
        size="small"
        onClick={handleRedirect}
        disabled={isLoading}
        sx={{ 
          color: '#1976d2', 
          padding: '4px',
          '&:hover': { backgroundColor: 'rgba(25, 118, 210, 0.04)' }
        }}
      >
        {isLoading ? (
          <CircularProgress size={16} />
        ) : (
          <OpenInNewIcon sx={{ fontSize: '16px' }} />
        )}
      </IconButton>
    </Tooltip>
  );
};

  const [showApprovalMessage, setShowApprovalMessage] = useState(false);

  const [selectedReSources, setSelectedResources] = useState([])

  const actionIconMap = {


    CLONERESOURCE: <FileCopyOutlinedIcon fontSize="small" />,
    EDIT: <EditOutlinedIcon fontSize="small" />,
    BULKUPLOAD: <UploadIcon fontSize="small" />,  // already outlined style
    START_STOP: <PowerSettingsNewOutlinedIcon fontSize="small" />,
    BULKUPLOADTAG: <LocalOfferOutlinedIcon fontSize="small" />,
    CANCELCR: <CancelOutlinedIcon fontSize="small" />,

  };



  //  Example inside your list/grid page
  const handleEditRow = (row) => {
    navigate("/Resources/Create_Request", {
      state: {
        resourceId: row.resourceTypeId,       
        resourceName: row.resourceName,      
        editResourceId: row.resourceId,
        mode: "edit",                        
        clonedResource: false,
        activeTab: 1
      },
    });
  };

  const handleCloneRow = (row) => {
    navigate("/Resources/Create_Request", {
      state: {
        resourceId: row.resourceTypeId,
        resourceName: row.resourceName,
        editResourceId: row.resourceId,
        mode: "clone",
        clonedResource: true,
      },
    });
  };

  useEffect(() => {
    const storedMessageVisibility = localStorage.getItem('showApprovalMessage');
    setShowApprovalMessage(storedMessageVisibility === 'true');
  }, []);

  const handleToggleExpand = (resourceId) => {
    setExpandedRows((prev) => {
      const newExpandedRows = {
        ...prev,
        [resourceId]: !prev[resourceId],
      };
      return newExpandedRows;
    });
  };



  const getInstanceStatus = async (instanceIds = []) => {
    try {
      const activeAccountId =
        sessionStorage.getItem("activeAccountId") ||
        sessionStorage.getItem("activeAccountId");

      if (!activeAccountId) {
        toast.error("Active account not selected");
        throw new Error("Missing accountId");
      }

      const response = await api.post(
        `/api/AwsEc2Data/GetInstanceStatus?accountId=${activeAccountId}`,
        instanceIds
      );

      return response.data; // array from backend
    } catch (error) {
      console.error("Error fetching instance status:", error);
      toast.error("Failed to fetch instance status");
      throw error;
    }
  };




  const handleResourceClick = (resource) => {
    setSelectedResource(resource);
    setDrawerOpen(true);
  }
  const handleStatusDialogClose = () => {
    setStatusDialogOpen(false);
  };
  const handleRefreshResources = async () => {
    try {
      await fetchResources();
    } catch (error) {
      console.error("Refresh failed", error);
      toast.error("Failed to refresh records");
    }
  };





  // Add a useEffect for approval settings
  useEffect(() => {
    const fetchApprovalSettings = async () => {

      const organizationId = sessionStorage.getItem('organizationId')

      try {
        const response = await api.get(`/Client/checkapprovalsettings/${organizationId}`, {
          params: { resourcetypeId: resourceId },
          headers: { 'X-CORRELATION-ID': 'd07cde5d-593f-45f1-9c27-50936fd6cf56' },
        });
        const settings = response.data;
        setApprovalSettings(settings);
        setShowApprovalMessage(settings.length === 0);

      } catch (error) {
        console.error('Error fetching approval settings:', error);
        setShowApprovalMessage(true); // Show message if there's an error fetching settings

      }
    };


    fetchApprovalSettings();
  }, [resourceId]);

  useEffect(() => {
    localStorage.setItem('showApprovalMessage', showApprovalMessage);
  }, [showApprovalMessage]);


  const resolveStatus = React.useCallback((row) => {
    if (row.resourceStatus == null && row.isDeployed === false) {
      return "not deployed";
    }
    return (row.resourceStatus || "").toLowerCase();
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchText(searchText.trim());
    }, 400);

    return () => clearTimeout(timer);
  }, [searchText]);

  const handleSearchChange = (newSearchTerm) => {
    setSearchText(newSearchTerm);
    setExpandedRows({});
    setSelectedRows([]);
    setSelectedResources([]);
    setPaginationModel((prev) => ({ ...prev, page: 0 }));
  };



  const isEC2 = resourceName?.toLowerCase() === "ec2";
  const selectedProvider = (localStorage.getItem("selectedProvider") || "").toLowerCase();

  const isViewAllResourcesPage = !resourceName;

  // Format date function
  const formatDate = (dateString) => {
    if (!dateString) return ''; // Return an empty string if dateString is undefined


    // Remove the milliseconds part if it exists
    const correctedDateString = dateString.split('.')[0] + 'Z'; // Add 'Z' to denote UTC


    const date = new Date(correctedDateString);

    if (Number.isNaN(date.getTime())) {
      console.error('Invalid date:', correctedDateString); // Log if the date is invalid
      return 'Invalid Date';
    }

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  };

  const pulseVariants = {
    initial: { scale: 0.9, opacity: 0.7 },
    animate: {
      scale: [0.9, 1.2, 0.9],
      opacity: [0.7, 1, 0.7],
      transition: {
        duration: 1.5,
        repeat: Infinity,
      },
    },
  };

  const runningIndicatorColors = {
  'running': isDark ? '#81c784' : '#2e7d32',          
  'getting provisioned': isDark ? '#ffb74d' : '#e68a00',
  'not deployed': isDark ? '#4fc3f7' : '#0288d1',       
  'Not Deployed': isDark ? '#4fc3f7' : '#0288d1',
  'stopped': isDark ? '#e57373' : '#d32f2f',            
  'terminated': isDark ? '#9e9e9e' : '#757575',         
  'git failure': isDark ? '#ef5350' : '#7a1f1f',        
  'delayed': isDark ? '#4fc3f7' : '#0288d1',            
  'canceled': isDark ? '#90a4ae' : '#546e7a',           
  'null': isDark ? '#b0bec5' : '#455a64',
};



 const fetchResources = async () => {
  setLoading(true);

  try {
    const resourceType = resourceId;
    const catalogueSelection = localStorage.getItem("catalogueSelection");
    const activeAccountId = sessionStorage.getItem("activeAccountId");

    const isOperational = catalogueSelection === "Operational";
    let accountId = activeAccountId;

    if (!accountId || accountId === "null" || accountId === "undefined") {
      accountId = "";
    }

    const response = await api.get("/api/Resources/getAllRequests", {
      params: {
        userId: currentUserId,
        resourceType,
        Isoperational: isOperational,
        activeaccountId: accountId,
        pageNumber: paginationModel.page + 1,
        pageSize: paginationModel.pageSize,
        searchText: debouncedSearchText,
        statusFilter: selectedStatuses.length
  ? selectedStatuses.join(",")
  : null,

      },
    });

    // Read the total-count response header before using it.
    const headers = response.headers;

    const totalCountHeader =
      headers?.["x-total-count"] ??
      headers?.get?.("x-total-count") ??
      headers?.["X-Total-Count"];

    const parsedTotalCount = Number(totalCountHeader);

   
    if (
      totalCountHeader == null ||
      totalCountHeader === "" ||
      !Number.isFinite(parsedTotalCount)
    ) {
      console.error(
        "X-Total-Count is missing or unavailable to the frontend."
      );
      setTotalCount(0);
    } else {
      setTotalCount(parsedTotalCount);
    }

    const responseRows = Array.isArray(response.data) ? response.data : [];

    const uniqueResources = responseRows.filter(
      (resource, index, allResources) =>
        index ===
        allResources.findIndex(
          (item) => item.resourceId === resource.resourceId
        )
    );

    setResources(uniqueResources);

    // Accept parentId as 0, "0", or null.
    const parentRows = uniqueResources.filter(
      (resource) =>
        resource.parentId == null || Number(resource.parentId) === 0
    );

    // console.log(
    //   "parentId values:",
    //   responseRows.slice(0, 5).map((resource) => resource.parentId)
    // );

    setFilteredResources(parentRows);
    setExpandedRows({});
    setSelectedRows([]);
    setSelectedResources([]);

    if (responseRows.length > 0) {
      setResourceTypeId(responseRows[0].resourceTypeId);
    }
  } catch (error) {
    console.error("Error fetching resources:", error);
  } finally {
    setLoading(false);
  }
};


  useEffect(() => {
    fetchResources();
  }, [resourceId, currentUserId, paginationModel.page, paginationModel.pageSize, debouncedSearchText,selectedStatuses]);

  const [downloadLoading, setDownloadLoading] = useState(false);
  const [canUpload, setCanUpload] = useState(false);

  const fileInputRef = React.useRef(null);
  const [uploadLoading, setUploadLoading] = useState(false);

  const handleDownloadResources = async () => {
  try {
    setDownloadLoading(true);
    const activeAccountId = sessionStorage.getItem('activeAccountId') || "";
    const correlationId = crypto.randomUUID();
    const response = await api.get(
      "/api/Resources/DownloadResourceTagExcel",
      {
        params: {
          userId: currentUserId, 
          accountId: activeAccountId,
        },
        responseType: "blob",
        headers: {
          "X-CORRELATION-ID": correlationId,
          Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
      }
    );

    const blob = new Blob([response.data], {
      type: response.headers["content-type"],
    });

    let fileName = ""; 

    const contentDisposition = response.headers["content-disposition"];

    if (contentDisposition) {
      const utf8Match = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);
      const standardMatch = contentDisposition.match(/filename="?([^";\n]+)"?/i);

      if (utf8Match && utf8Match[1]) {
        fileName = decodeURIComponent(utf8Match[1]);
      } else if (standardMatch && standardMatch[1]) {
        fileName = standardMatch[1];
      }
    }

    if (!fileName) {
      console.warn("API filename not found! The backend MUST expose the Content-Disposition header.");
      fileName = "Fallback_Name_Because_API_Header_Was_Hidden.xlsx"; 
    }

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;

    document.body.appendChild(link);
    link.click();

    link.remove();
    window.URL.revokeObjectURL(url);

    toast.success("Resources downloaded successfully");
    setCanUpload(true);

  } catch (error) {
    console.error("Download failed:", error);
    toast.error("Failed to download resources");
  } finally {
    setDownloadLoading(false);
  }
};

const handleUploadExcel = async (file) => {
  if (!file) return;

  try {
    setUploadLoading(true);
    const activeAccountId = sessionStorage.getItem('activeAccountId') || "";
    const correlationId = crypto.randomUUID();
    const formData = new FormData();
    formData.append("file", file);
    
    const response = await api.post(
      "/api/Resources/UploadResourceTagExcel",
      formData,
      {
        params: { userId: currentUserId, accountId: activeAccountId},
        headers: {
          "X-CORRELATION-ID": correlationId,
          Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
        responseType: "blob",
      }
    );

    const blob = new Blob([response.data], { type: response.headers["content-type"] });
    
    let fileName = ""; 
    const contentDisposition = response.headers["content-disposition"];
    
    if (contentDisposition) {
      const parts = contentDisposition.split(';');
      
      for (let part of parts) {
        part = part.trim(); 
        
        if (part.startsWith("filename*=")) {
          const namePart = part.replace("filename*=UTF-8''", "");
          fileName = decodeURIComponent(namePart);
          break; 
        } else if (part.startsWith("filename=")) {
          fileName = part.replace("filename=", "").replace(/"/g, "");
        }
      }
    }

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    toast.success("Excel uploaded successfully");
    await fetchResources();
    setIsBulkTagPopupOpen(false);

  } catch (error) {
    console.error("Upload failed:", error);
    
    let errorMessage = "Failed to upload Excel file. Please check your data and try again.";

    if (error.response?.data instanceof Blob) {
      const errorText = await error.response.data.text();
      
      try {
        const errorJson = JSON.parse(errorText);
        
        if (errorJson.errors && typeof errorJson.errors === 'object') {
          errorMessage = Object.values(errorJson.errors).flat().join(" ");
        } else {
          errorMessage = errorJson.message || errorJson.errorMessages || errorJson.title || errorText;
        }
      } catch (e) {
        errorMessage = errorText || errorMessage;
      }
    }

    toast.error(errorMessage);

  } finally {
    setUploadLoading(false);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  }
};

const handleFileSelect = (event) => {
  const file = event.target.files?.[0];

  if (!file) return;

  if (
    !file.name.endsWith(".xlsx") &&
    !file.name.endsWith(".xls")
  ) {
    toast.error("Please upload a valid Excel file");
    return;
  }

  handleUploadExcel(file);
};
  const handleScheduleDialogClose = () => {
    setScheduleDialogOpen(false);
    setScheduleAction(null);
    setSelectedResourceForAction(null);
  };


 const handleScheduleConfirm = async (scheduledDateTime) => {
  if (!currentInstanceStates || currentInstanceStates.length === 0) {
    toast.error("No instances selected for scheduling.");
    return;
  }

  try {
    const isStartRequest = scheduleAction === 'start';
    
    const eligibleState = scheduleAction === 'start' ? 'stopped' : 'running';

    const payload = currentInstanceStates
      .filter(d => d.state?.toLowerCase() === eligibleState)
      .map(d => {
        return {
          resource_Id: d.resourceId,
          isStartStopRequest: isStartRequest,
          scheduledDateTime: scheduledDateTime.toISOString(),
          isRequestCompleted: false,
          createdDate: new Date().toISOString(),
          createdBy: currentUserId
        }
      });

    if (payload.length === 0) {
      toast.info(`No eligible instances to schedule a ${scheduleAction} action.`);
      handleScheduleDialogClose();
      return;
    }

    const response = await api.post('/api/Resources/createInstanceStartStopRequest', payload);
    
    if (response.status === 200 || response.data?.httpStatusCode === 200 || response.data === true) {
      toast.success(
        `Instance ${scheduleAction} scheduled successfully for ${scheduledDateTime.toLocaleString()}`
      );
      await fetchResources();
    } else {
      throw new Error(response.data?.errorMessages || 'Failed to schedule action');
    }

  } catch (error) {
    console.error('Error scheduling instance action:', error);
    const errorMessage = error.response?.data?.errorMessages || error.message || 'Failed to schedule action';
    toast.error(`Error: ${errorMessage}`);
  } finally {
    handleScheduleDialogClose();
  }
};
  
  const getStatusStyles = (status) => {
    const statusString = (status || '').toString().toLowerCase();
    switch (statusString) {
      case 'running':
        return {
          color: 'white',
          backgroundColor: runningIndicatorColors['running'],
          cursor: 'pointer',
          padding: '5px',
          borderRadius: '4px',
        };

      case 'not deployed':
        return {
          color: 'white',
          backgroundColor: runningIndicatorColors['not deployed'],
          cursor: 'pointer',
          padding: '5px',
          borderRadius: '4px',

        };
      case 'pending':
        return {
          color: 'white',
          backgroundColor: runningIndicatorColors['getting provisioned'],
          cursor: 'pointer',
          padding: '5px',
          borderRadius: '4px',

        };
      case 'getting provisioned':
        return {
          color: 'white',
          backgroundColor: runningIndicatorColors['getting provisioned'],

          cursor: 'pointer',
          padding: '5px',
          borderRadius: '4px',
          textTransform: "captialize",

        };
      default:
        return {
          color: 'white',
          backgroundColor: 'transparent',
          cursor: 'pointer',
          padding: '5px',
          borderRadius: '4px',
          textTransform: "captialize",

        };
    }
  };

  const getStatusChipColor = (status) => {
    const normalizedStatus = (status || '').toLowerCase();

    const colorMap = {
      'running': 'success',           // Green
      'stopped': 'error',             // Red
      'getting provisioned': 'warning', // Orange/Yellow
      'pending': 'warning',           // Orange/Yellow
      'not deployed': 'info',
      'git failure': 'gitFailure',
      'Terminated': 'default',
      'delayed': 'delayed',
      'canceled':'canceled',
      // 'not deployed': 'default',      // Gray
    };

    return colorMap[normalizedStatus] || 'default';
  };

const isAdditionalDisk = (resource) => {
  const operation = (resource.operationSupport || "").trim().toLowerCase();
  return operation === "additional disk" || operation === "additional disk edit";
};

const getAdditionalDiskChildren = (parentId) =>
  resources.filter(
    (resource) =>
      resource.parentId === parentId && isAdditionalDisk(resource)
  );

  const formatPrice = (value) => {
  if (value == null || value === "") return "-";

  const amount = Number(value);
  return Number.isFinite(amount) ? `$${amount.toFixed(2)}` : "-";
};



const renderCenteredPrice = (value) => (
  <Box
    sx={{
      width: "100%",
      height: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
    }}
  >
    <Typography variant="body2" sx={{ textAlign: "left" }}>
      {formatPrice(value)}
    </Typography>
  </Box>
);


  // Usage in DataGrid columns
  const parentColumns = [

    {
      field: 'runningIndicator',
      headerName: 'Status',
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      flex: 0.42,
      renderCell: (params) => {
        const status = resolveStatus(params.row);
        const isRunning = status === 'running';

        return isRunning ? (
          <motion.div
            className="running-indicator"
            variants={pulseVariants}
            initial="initial"
            animate="animate"
            style={{
              display: 'inline-block',
              width: '10px',
              height: '10px',
              borderRadius: '50%',
              marginLeft: "15px",
              backgroundColor: runningIndicatorColors['running'],
            }}
          />
        ) : (
          <div
            style={{
              display: 'inline-block',
              width: '10px',
              height: '10px',
              borderRadius: '50%',
              marginLeft: "15px",
              textAlign: 'center',
              backgroundColor: runningIndicatorColors[status] || '#0288d1',
            }}
          />
        );
      },
    },

   {
      field: 'applicationName',
      headerName: 'Application Name',
      align: 'left',
      headerAlign: 'left',
      flex: 1.2,
      renderCell: (params) => {
        // const hasChildren = resources.some(resource => resource.parentId === params.row.resourceId);
        const hasChildren = resources.filter(
  resource =>
    resource.parentId === params.row.resourceId &&
    (resource.operationSupport?.toLowerCase() === "additional disk" ||  resource.operationSupport?.toLowerCase() === "additional disk edit")
).length > 0;
        const isChild = params.row.indent;

        return (
          <Box 
            sx={{ 
              display: 'flex', 
              alignItems: 'center', 
              height: '100%',       
              width: '100%', 
              gap: 1 
            }}
          >
            
            {/* LEFT SIDE: Arrow (if child) and Application Name */}
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, overflow: 'hidden' }}>
              {isChild && (
                <SubdirectoryArrowRightIcon sx={{ fontSize: '20px', color: '#666', minWidth: '24px' }} />
              )}

              <Typography
                variant="body2"
                title={params.value || ''}
                sx={{
                  color: '#1976d2',
                  textDecoration: !isChild ? 'underline' : 'none',
                  cursor: !isChild ? 'pointer' : 'default',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis'
                }}
                onClick={() => !isChild && handleResourceClick(params.row)}
              >
                {params.value}
              </Typography>
            </Box>

            {/* RIGHT SIDE: The expand/collapse Icon with corrected Tooltip */}
            {!isChild && hasChildren && (
              <Tooltip 
                title={expandedRows[params.row.resourceId] ? "Hide attached disks" : "Show attached disks"} 
                arrow 
                placement="top"
              >
                <IconButton
                  onClick={(e) => {
                    e.stopPropagation(); // Prevents row selection from firing
                    handleToggleExpand(params.row.resourceId);
                  }}
                  sx={{ 
                    padding: '4px', 
                    marginLeft: 'auto' // Pushes the icon to the right edge
                  }}
                >
                  {expandedRows[params.row.resourceId] ? (
                    <RemoveIcon fontSize="small" />
                  ) : (
                    <AddIcon fontSize="small" color="primary" />
                  )}
                </IconButton>
              </Tooltip>
            )}

          </Box>
        );
      },
    },
    {
      field: 'resourceNameConstraint',
      headerName: 'Resource Name',
      width: 250,
      flex: 1.3,
      alignItems: 'center',
      renderCell: (params) => {
        const value = params.value || '-';
        return (
          <span title={value}>{value}</span>
        );
      }
    },
    {
      field: 'awsInstanceId',
      headerName: 
isEC2
    ? 'Resource Id (Logic Monitor URL)'
    : 'Resource Id',

      
renderHeader: () => (
  <Typography variant="body2" fontWeight={600}>
      {isEC2
        ? 'Resource Id (Logic Monitor URL)'
        : 'Resource Id'}
    </Typography>

),

      width: 180,
      flex: 1.3,
      alignItems: 'center',
      renderCell: (params) => {
        const instanceId = params.value;
        
const isEC2 =
      params.row.resourceName?.toLowerCase() === 'ec2';


      const status = resolveStatus(params.row);

const isAdditionalDisk = params.row.indent ||  params.row.operationSupport?.trim().toLowerCase() === "additional disk" ||  params.row.operationSupport?.trim().toLowerCase() === "additional disk edit" ;

      const showLogicMonitorIcon =
  isEC2 && 
  !isViewAllResourcesPage&&
  !isAdditionalDisk &&
  params.row.isResourceAddedFromCMP === true &&
  ["running", "stopped"].includes(status);
;


        if (!instanceId || instanceId === '-') return '-';

        return (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, height: '100%' }}>
            <Typography title={instanceId} variant="body2" sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
              {instanceId}
            </Typography>
            
            {/* THIS IS THE FIX: Use the new mini-component instead of the old IconButton */}
           {showLogicMonitorIcon  && <LogicMonitorButton instanceId={instanceId} />
      }
          </Box>
        );
      }
    },
     {
  field: "price",
  headerName: "Price per Month",
  minWidth: 170,
  flex: 0.7,
  align: "left",
  headerAlign: "left",
  sortable: false,
  filterable: false,
 renderCell: (params) => {
  const row = params.row;

  // Expanded child row: show that resource's own API price.
  if (row.indent) {
    return renderCenteredPrice(row.price);
  }

  // Expanded parent: show the instance's own price.
  if (expandedRows[row.resourceId]) {
    return renderCenteredPrice(row.price);
  }

  // Collapsed parent: show the backend total, falling back to price
  // if totalPrice is absent.
  return renderCenteredPrice(row.totalPrice ?? row.price);
},

},
    {
      field: 'resourceName',
      headerName: 'Resource Type',
      align: 'left',
      flex: 1.1,
      minWidth: 150,
      renderCell: (params) => {
        const resourceStatus = resolveStatus(params.row);
        const isCMP = params.row.isResourceAddedFromCMP;
        // const isAdditionalDisk = params.row.indent === true && params.row.operationSupport === "Additional Disk";

        // const displayType = isAdditionalDisk ? "Additional Disk" : params.value || "-";

        const displayType =
  params.row.indent &&
  params.row.operationSupport
? params.row.operationSupport.toLowerCase().includes("additional disk edit")
      ? "Additional Disk"
  : params.row.operationSupport
    : params.value || "-";

        const chipColor = getStatusChipColor(resourceStatus);
        const chipBg = {
          primary: runningIndicatorColors["not deployed"],
          success: runningIndicatorColors["running"],
          warning: runningIndicatorColors["getting provisioned"],
          error: runningIndicatorColors["stopped"],
          info: '#0288d1',
          gitFailure: runningIndicatorColors["git failure"],
          delayed: runningIndicatorColors["delayed"],
          canceled :  runningIndicatorColors["canceled"],
          default: runningIndicatorColors["terminated"]
        }[chipColor] || '#808080';
        return (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              borderRadius: "12px",
              overflow: "hidden",
              height: 26,
              backgroundColor: chipBg,
              color: "#ffffff",
              minWidth: 120,
              maxWidth: 180,
              mt: 1.5,
            }}
          >
            <Box sx={{ flex: 1, display: "flex", justifyContent: "center", alignItems: "center", fontSize: "0.70rem", px: 4, mt: 0.3, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
              {displayType}
            </Box>
            {isCMP && <Box sx={{ width: "1px", backgroundColor: "rgba(255,255,255,0.5)", height: "60%" }} />}
            {isCMP && (
              <Box sx={{ flex: 1, display: "flex", justifyContent: "center", alignItems: "center", fontSize: "0.65rem", fontWeight: 600, color: "#fff", mt: 0.3, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                CMP
              </Box>
            )}
          </Box>
        );
      },
    }, 
   {
      field: 'createdDate',
      headerName: 'Created Date',
      align: 'left',
      headerAlign: 'left',
      flex: 1,
      valueGetter: (params) => formatDate(params)
    },
    // The conditional check wrapper has been removed here.
    // The Actions column is now a standard, permanent object in the array.
    {
      field: "actions",
      headerName: "Actions",
      flex: 0.48,
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        const row = params.row;

        const onAction = (code, rowData) => {
        switch (code) {
          case "EDIT": handleEditRow(rowData); break;
          case "CLONERESOURCE": handleCloneRow(rowData); break;
          case "START_STOP_MENU": handleThreeDotClick(rowData); break;
          case "CANCELCR": toast.info("Cancel CR not implemented"); break;
          default: toast.info(`${code} not implemented`);
        }
      };

        return (
          <RowActionMenu
            row={row}
            actionIconMap={actionIconMap}
            onAction={onAction}
            resolveStatus={resolveStatus}
          />
        );
      }
    }
  ];
  const rows = [];

  filteredResources.forEach(parent => {
    const parentStatus = resolveStatus(parent);
    if (selectedStatuses.length > 0 && !selectedStatuses.includes(parentStatus)) {
      return; 
    }
    // always push parent ONCE
    rows.push({
      ...parent,
      id: parent.resourceId,
      indent: false
    });

    // if expanded, push only its direct children
    if (expandedRows[parent.resourceId]) {
      // const children = resources.filter(r => r.parentId === parent.resourceId);
      const children = resources.filter(
  r =>
    r.parentId === parent.resourceId &&
    (r.operationSupport?.toLowerCase() === "additional disk" ||  r.operationSupport?.toLowerCase() === "additional disk edit")
);



      children.forEach(child => {
        rows.push({
          ...child,
          id: `child-${child.resourceId}`,
          indent: true
        });
      });
    }

  });

  const handleThreeDotClick = async (resource) => {
    setActionDialogOpen(true);
    setDialogLoading(true);

    try {
      //  Build instanceIds correctly
      const instanceIds = resource
        ? [resource.awsInstanceId]
        : selectedReSources.map(r => r.awsInstanceId);

      if (!instanceIds.length) {
        toast.info("No instances selected");
        setActionDialogOpen(false);
        return;
      }

      //  USE the helper function (fixes ESLint warning)
      const data = await getInstanceStatus(instanceIds);

      const sourceResources = resource ? [resource] : selectedReSources;

      const instanceStateVal = sourceResources.map(d => {
        const match = data.find(
          obj => obj.instanceId === d.awsInstanceId
        );

        return {
          applicationName: d.applicationName,
          resourceNameConstraint:
            d.resourceNameConstraint || d.resource_Name || "-",
          awsInstanceId: d.awsInstanceId,
          state: match?.state?.toLowerCase() || "notfound",
          resourceId: d.resourceId
        };
      });

      setCurrentInstanceState(instanceStateVal);
    } catch (error) {
      setActionDialogOpen(false);
    } finally {
      setDialogLoading(false);
    }
  };


  // Handler 2: Close dialog
  const handleCloseDialog = () => {
    setActionDialogOpen(false);
    setSelectedResource(null);
    setCurrentInstanceState([]);
    setActionLoading(false);
    fetchResources();
  };

  const isSingle = currentInstanceStates.length === 1;
  const isMultiple = currentInstanceStates.length > 1;

  const singleState = currentInstanceStates[0]?.state?.toLowerCase();

  const BLOCKED_STATES = ["processing", "error", "notfound"];

  const hasProcessing =
    currentInstanceStates.some(i =>
      BLOCKED_STATES.includes(i.state?.toLowerCase())
    );


const normalizedStates = currentInstanceStates.map(i => i.state?.toLowerCase());

const allRunning =
  currentInstanceStates.length > 0 &&
  normalizedStates.every(state => state === "running");

const allStopped =
  currentInstanceStates.length > 0 &&
  normalizedStates.every(state => state === "stopped");

  const handleScheduleAction = () => {
    if (!currentInstanceStates.length) {
      toast.info("No instances available to schedule");
      return;
    }

    if (hasProcessing) {
      toast.info("Please wait until all instances finish processing");
      return;
    }

    // Mixed running + stopped is allowed
    const hasRunning = currentInstanceStates.some(i => i.state === "running");
    setScheduleAction(hasRunning ? "stop" : "start");

    setScheduleDialogOpen(true);
  };

  const handleExecuteAction = async (action) => {
    setActionLoading(true);

    try {
      const isStartRequest = action === 'start';

      const payload = currentInstanceStates.map(d => {
        return {
          resource_Id: d.resourceId,
          isStartStopRequest: isStartRequest,
          scheduledDateTime: new Date().toISOString(),
          createdDate: new Date().toISOString(),
          createdBy: currentUserId,
          isRequestCompleted: false
        }
      });



      const response = await api.post(
        '/api/Resources/createInstanceStartStopRequest',
        payload
      );



      if (response.data === true || response.status === 200) {
        toast.success(`Instance ${action} request submitted successfully!`);
        handleCloseDialog();
        await fetchResources();
      } else {
        throw new Error('Request failed');
      }

    } catch (error) {

      const errorMsg = error.response?.data?.errorMessages || error.message;
      toast.error(`Failed to ${action} instance: ${errorMsg}`);
    } finally {
      setActionLoading(false);
    }
  };

  return (
    <Layout pageType='sideBar'>
      <Box sx={{ flex: 1, px: 2, color: theme.palette.text.primary }}>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <Box>
            {resourceName ?
            <Typography variant="title" gutterBottom sx={{ marginTop: '20px', textTransform: "capitalize" }}>{resourceName} Resource </Typography>: (<Typography variant="title" gutterBottom sx={{ marginTop: '20px', textTransform: "capitalize" }}> View All Resources</Typography>)}
          </Box>
          <Box sx={{ display: 'flex', gap:1, justifyContent: 'end', alignItems: 'center' }}>
            <SearchComponent value={searchText} onSearchChange={handleSearchChange} sx={{ m: 0, mt: '2px' }} />
            <Box sx={{ gap: 1, display: 'flex', }}   >
              {resourceId &&
                // !areApprovalSettingsMissing &&       
                !isCreateDisabled && (
                   

                  <Button variant="contained" onClick={() => navigate(`/Resources/View_Resources/template-gallery?resourceId=${resourceId}&provider=${localStorage.getItem("selectedProvider")}&resourceName=${resourceName}`)}>
                    Create {resourceName} / Choose Template
                  </Button>
                
                )}
               
{isUploadDownloadTag && isBulkTagAllowed && (
  <>
    {/* Primary Bulk Tag Button */}
    <RoleGuard requiredPermission= "BULK_TAGS">
    <Button
      variant="outlined"
      onClick={() => setIsBulkTagPopupOpen(true)}
    >
      Bulk Tag
    </Button>
    </RoleGuard>

    {/* Popup / Dialog */}
    <Dialog 
      open={isBulkTagPopupOpen} 
      onClose={() => setIsBulkTagPopupOpen(false)}
      maxWidth="sm" 
      fullWidth
      PaperProps={{
        sx: { borderRadius: 2 } 
      }}
    >
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pb: 1 }}>
        <Typography variant="h6" component="div" fontWeight="600">
          Bulk Tags
        </Typography>
        <IconButton onClick={() => setIsBulkTagPopupOpen(false)} size="small" sx={{ color: 'text.secondary' }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      
      <DialogContent sx={{ p: 0 }}> 
        <Box sx={{ display: 'flex', flexDirection: 'column', p:2,}}>

           <Box 
            sx={{ 
              p: 1, 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'space-between',
              bgcolor: 'background.paper',
              gap:2
            }}
          >
            <Box>
              <Typography variant="subtitle2" fontWeight="600" color="text.primary">
               Download Required
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Please download your latest tags from the system first. You cannot upload a file until this step is complete.
              </Typography>
            </Box>
            
            <Button
              variant="outlined"
              disabled={downloadLoading || uploadLoading}
              onClick={handleDownloadResources}
              sx={{ minWidth: 140}} // Prevents button from resizing during loading text changes
            >
              {downloadLoading ? "Downloading..." : "Download Tags"}
            </Button>
          </Box>
          
          {/* TOP SECTION: Drag & Drop Upload Area */}
          <Box
            sx={{
              p: 6,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              bgcolor: 'grey.50', 
              border: '1px dashed #ccc',
              cursor: uploadLoading ? 'default' : 'pointer',
              transition: 'background-color 0.2s ease-in-out',
              '&:hover': {
                bgcolor: uploadLoading ? 'grey.50' : 'grey.100',
              },
            }}
            onClick={() => !uploadLoading && fileInputRef.current?.click()}
          >
            {uploadLoading ? (
               <CircularProgress size={48} sx={{ mb: 2 }} />
            ) : (
               <CloudUploadIcon sx={{ fontSize: 56, color: 'primary.light', mb: 2 }} />
            )}
            
            <Typography variant="subtitle1" fontWeight="600" color="text.primary" gutterBottom>
              {uploadLoading ? "Uploading tags..." : "Drag and drop your tags file here"}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
              or click to browse from your computer
            </Typography>
            <Typography variant="caption" color="text.disabled" fontWeight="500">
              Supports .xlsx or .csv files only
            </Typography>
          </Box>

          <Divider sx={{ borderStyle: 'dashed' }} />

         

        </Box>
      </DialogContent>
    </Dialog>
    
    {/* Hidden File Input */}
    <input
      type="file"
      ref={fileInputRef}
      style={{ display: 'none' }}
      onChange={handleFileSelect}
      accept=".xlsx, .xls, .csv" 
    />
  </>
)}
              <Tooltip title="Refresh records" arrow>
                <span>
                  <Button
                    variant="outlined"
                    onClick={handleRefreshResources}
                    disabled={loading}
                    sx={{
                      width: 30,
                      height: 30,
                      minWidth: 30,
                      minHeight: 30,
                      padding: "17px",
                      borderRadius: 1,
                      color: "#2e7d32",
                      borderColor: "#2e7d32",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",

                      "& .MuiButton-startIcon": {
                        margin: 0,
                      },

                      "&:hover": {
                        borderColor: "#1b5e20",
                        backgroundColor: "#00a00b",
                        color: 'white',
                      },
                    }}
                  >
                    {loading ? (
                      <CircularProgress size={14} />
                    ) : (
                      <RefreshIcon fontSize="small" />
                    )}
                  </Button>
                </span>

              </Tooltip>
            </Box>
          </Box>
        </Box>

         {/* {showApprovalMessage && (
          <Alert
            severity="info"
            icon={<InfoOutlineRounded fontSize="inherit" />}
            sx={{
              mb: 3,
              alignItems: 'center',
              '& .MuiAlert-message': {
                display: 'flex',
                alignItems: 'center',
                width: '100%'
              }
            }}
          >
            <Box sx={{ flexGrow: 1 }}>
              Approval workflows are not configured for this resource type 
            </Box>

          </Alert>
        )}  */}



        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            mt: 2,
            mb: 1,
          }}
        >

          {/* Right SIDE — BULK ACTION BUTTON */}
          {/* {selectedRows.size > 0 && ( */}
          {isBulkAction && isEC2 && (
            <RoleGuard requiredPermission="BULK_START_STOP">
            <Button
              flex={1}
              variant="contained"
              color="primary"
              sx={{ mr: 2 }}
              disabled={selectedReSources.length < 2}
              onClick={() => handleThreeDotClick("")}
            >
              Bulk Action
            </Button>
            </RoleGuard>
          )}

          {/* Right SIDE — FILTER CHIPS */}
<Box display="flex" gap={1.5} sx={{ marginLeft: 'auto', flexWrap: 'wrap', justifyContent: 'flex-end', alignItems: 'center' }}>
  {
    [
      { key: 'running', label: 'Running' },
      { key: 'getting provisioned', label: 'Getting Provisioned' },
      { key: 'not deployed', label: 'Not Deployed' },
      { key: 'stopped', label: 'Stopped' },
      { key: 'git failure', label: 'Git Failure' },
      { key: 'terminated', label: 'Terminated' },
      { key: 'canceled', label: 'Canceled / Rejected' }
    ].map((status) => {
      const isSelected = selectedStatuses.includes(status.key);
      const statusColor = runningIndicatorColors[status.key] || '#808080';

      return (
        <Tooltip 
          key={status.key} 
          title={`Filter by ${status.label} status`} 
          arrow
          slotProps={{
            tooltip: {
              sx: {
                bgcolor: statusColor, 
                color: '#ffffff',
                fontSize: '12px',
                fontWeight: 500,
              },
            },
            arrow: {
              sx: {
                color: statusColor, 
              },
            },
          }}
        >
          <Chip
            label={status.label}
            onClick={() => handleStatusToggle(status.key)}
            variant={isSelected ? "filled" : "outlined"}
            
            icon={
              isSelected ? (
                <CheckCircleIcon sx={{ fontSize: 18, ml: 0.5, color: statusColor }} />
              ) : (
                <CircleIcon sx={{ fontSize: 12, ml: 1, color: statusColor }} /> 
              )
            }
            
            sx={{
              height: '24px',
              border: 'none',
              borderColor: isSelected ? 'transparent' : `${statusColor}80`,
              backgroundColor: isSelected ? `${statusColor}15` : 'transparent',
              color: isSelected ? statusColor : 'text.secondary',
              fontWeight: isSelected ? 600 : 400,
              boxShadow: isSelected 
                ? (theme.palette.mode === 'dark' ? '0px 2px 4px rgba(0, 0, 0, 0.4)' : '0px 2px 4px rgba(0, 0, 0, 0.12), 0px 1px 2px rgba(0, 0, 0, 0.08)') 
                : 'none',
              transition: 'all 0.2s ease-in-out',
              '&:hover': {
                backgroundColor: `${statusColor}25`,
              },
              '& .MuiChip-icon': {
                marginRight: '4px',
                color: isSelected ? statusColor : `${statusColor}CC`, 
              },
              '& .MuiChip-label': {
                paddingLeft: 0, 
              }
            }}
          />
        </Tooltip>
      );
    })
  }
</Box>
        </Box>

        <Box sx={{ width: '100%', mt: 1, height:'calc(100vh - 200px)', minHeight: 380 }}>
           <DataGrid
  rows={rows}
  columns={parentColumns}
  loading={loading}
  pagination
  paginationMode="server"
  rowCount={totalCount}
  paginationModel={paginationModel}
  onPaginationModelChange={setPaginationModel}
  pageSizeOptions={[10, 20, 50, 100]}
  autoHeight={false}
  checkboxSelection={isBulkAction && isEC2 && bulkStartStop}
  disableRowSelectionOnClick
  hideFooterSelectedRowCount

  getRowId={(row) => row.id ?? row.resourceId}

  isRowSelectable={(params) => {
    if (!isEC2) return false;
    const resourceName = params.row.resourceName?.toLowerCase();
    const createdBy = params.row.createdBy;
    const resourceStatus = resolveStatus(params.row);
    const isResourceCreatedByReqUser = params.row.isResourceCreatedByReqUser;
    const isResourceAddedFromCMP = params.row.isResourceCreatedByReqUser;

                if (params.row.indent || resourceName === 'security groups' ||params.row.operationSupport?.toLowerCase() === 'additional disk edit' || resourceName === 's3 bucket' || resourceName === 'Additional Disk' || createdBy === 0 || (resourceStatus !== 'running' && resourceStatus !== 'stopped')
                  || !(isResourceCreatedByReqUser && isResourceAddedFromCMP)
    ) {
      return false;
    }
    return true;
  }}

  selectionModel={isEC2 ? selectedRows : []}
  onRowSelectionModelChange={(selectionModel) => {
    const selectedIds = Array.from(selectionModel.ids);

                const selected = rows.filter(row =>
                  selectedIds.includes(row.id)
                );
    setSelectedRows(selected);
    setSelectedResources(selected);
  }}

 sx={{
  border: "none",
  bgcolor: (t) => t.palette.mode === "dark" ? "background.paper" : "#ffffff",

    height: '100%',
    minHeight: 0,

  "& .MuiCheckbox-root.Mui-checked .MuiSvgIcon-root, & .MuiCheckbox-root.MuiCheckbox-indeterminate .MuiSvgIcon-root, & .MuiCheckbox-root.Mui-indeterminate .MuiSvgIcon-root": {
    color: (t) => `${t.palette.primary.main} !important`, 
  },
  
  "& .MuiCheckbox-root .MuiSvgIcon-root": {
    color: (t) => t.palette.mode === "dark" ? "rgba(255, 255, 255, 0.7)" : "rgba(0, 0, 0, 0.54)",
  },
  
  "& .MuiCheckbox-root.Mui-disabled .MuiSvgIcon-root": {
    color: (t) => `${t.palette.action.disabled} !important`,
  },

  "--DataGrid-rowBorderColor": "transparent",

  "& .MuiDataGrid-filler": { display: "none" },

  "& .MuiDataGrid-columnHeaders": {
    bgcolor: (t) => t.palette.mode === "dark" ? "background.default" : "#ffffff",
    color: "text.primary", 
    borderBottom: "none",
  },
  "& .MuiDataGrid-columnHeaderTitle": {
    fontWeight: "bold !important",
  },
  
  "& .MuiDataGrid-columnSeparator": {
    color: (t) => t.palette.mode === "dark" ? "rgba(255, 255, 255, 0.11)" : "rgba(0, 0, 0, 0.2)",
  },
  
  "& .MuiDataGrid-columnHeader .MuiSvgIcon-root:not(.MuiCheckbox-root .MuiSvgIcon-root)": {
    color: (t) => t.palette.mode === "dark" ? "rgba(255, 255, 255, 0.11)" : "rgba(0, 0, 0, 0.2)",
  },

  "& .MuiDataGrid-cell": {
    color: "text.primary",
    borderBottom: "none !important",
  },

  "& .MuiDataGrid-row:nth-of-type(even)": {
    bgcolor: (t) => t.palette.mode === "dark" ? "rgba(255, 255, 255, 0.02)" : "#fafafa",
  },
  "& .MuiDataGrid-row:nth-of-type(odd)": {
    bgcolor: (t) => t.palette.mode === "dark" ? "transparent" : "#ffffff",
  },

  "& .MuiDataGrid-row:hover": {
    bgcolor: (t) => t.palette.mode === "dark" ? "rgba(255, 255, 255, 0.08) !important" : "#e8f0fe !important",
  },

  "& .MuiDataGrid-row.Mui-selected": {
    bgcolor: (t) => t.palette.mode === "dark" ? "rgba(144, 202, 249, 0.16) !important" : "#e3f2fd !important",
  },
  "& .MuiDataGrid-row.Mui-selected:hover": {
    bgcolor: (t) => t.palette.mode === "dark" ? "rgba(144, 202, 249, 0.24) !important" : "#d0eafb !important",
  },

  "& .MuiDataGrid-footerContainer": {
    bgcolor: (t) => t.palette.mode === "dark" ? "background.default" : "#ffffff",
    borderTop: "none",
    color: "text.primary",
  },

  "& .floating-actions, & .row-actions": {
    backgroundColor: (t) => t.palette.mode === "dark" ? "rgba(40, 40, 40, 0.9)" : "#e8f0fe",
    flex: 1,
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    display: "flex",
    gap: "6px",
    opacity: 0,
    pointerEvents: "none",
    transition: "opacity 0.2s ease-in-out",
    padding: "4px 8px",
    borderRadius: "4px",
  },
  "& .MuiDataGrid-row:hover .floating-actions, & .MuiDataGrid-row:hover .row-actions, & .MuiDataGrid-row.Mui-selected .floating-actions, & .MuiDataGrid-row.Mui-selected .row-actions": {
    opacity: 1,
    pointerEvents: "auto",
  },

  "& .MuiDataGrid-cell[data-field='__floating_actions'], & .MuiDataGrid-cell[data-field='actions']": {
    overflow: "visible !important",
    width: "0px !important",
    padding: 0,
    borderBottom: "none !important",
  },
}}
/>
        </Box>


        <Drawer
          anchor="right"
          open={drawerOpen}  // Control with drawerOpen state
          onClose={() => {
            setDrawerOpen(false);
            setSelectedResource(null);
          }} slotProps={{
            paper: { sx: { width: "80vw" } }
          }}
        >
          {selectedResource && (

            <ApplicationNameDetails
              resource={selectedResource}
              resourceTypeId={resourceTypeId} // Pass resourceTypeId

              // resourceIds={selectedResource.resourceId}
              onCloseDrawer={() => {
                setDrawerOpen(false);
                setSelectedResource(null);
              }} />
          )}

        </Drawer>

        <Dialog open={statusDialogOpen} onClose={handleStatusDialogClose}>
          <ResourceStatusDialog
            open={statusDialogOpen}
            onClose={handleStatusDialogClose}
            resource={selectedResource}
          />
        </Dialog>

       <ScheduleDialog
          open={scheduleDialogOpen}
          onClose={handleScheduleDialogClose}
          onConfirm={handleScheduleConfirm}
          action={scheduleAction}
          resourceName={selectedResourceForAction?.applicationName || ''}
          onCloseParent={handleCloseDialog}
        />


        <Dialog
          open={actionDialogOpen}
          onClose={handleCloseDialog}
          maxWidth="md"
          fullWidth
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <DialogTitle sx={{ fontSize: '18px', fontWeight: 'Bold' }}>Instance Actions</DialogTitle>

             

            <IconButton onClick={handleCloseDialog} size="small" sx={{
              mr: '10px',
              width: '50px',
              height: '50px',
              mt: '8px'
            }}>
              <CloseIcon />
            </IconButton>
          </Box>

<Box>

<Alert severity="error" sx={{ mb: 2 }}>
              Disclaimer: Approval via SNOW (ServiceNow) will be required for all future service start/stop actions
             </Alert>

</Box>
          <DialogContent>
            {dialogLoading ? (
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', py: 4 }}>
                <CircularProgress />
                <Typography sx={{ ml: 2 }}>
                  Fetching instance status...
                </Typography>
              </Box>
            ) : (
              <Box sx={{ width: "100%" }}>
                <DataGrid
                  rows={currentInstanceStates.map((r) => ({
                    ...r,
                    id: r.awsInstanceId, // required by DataGrid
                  }))}
                  columns={instanceColumns}
                  hideFooter
                  disableRowSelectionOnClick
                  sx={{
                    "& .MuiDataGrid-columnHeaderTitle": {
                      fontWeight: "bold",
                    },
                  }}
                />
              </Box>
            )}
          </DialogContent>


          <DialogActions
            sx={{
              px: 3,
              pb: 2,
              flexDirection: "column",
              alignItems: "stretch",
            }}
          >
            {/* WARNING — ABOVE CANCEL */}
            {hasProcessing && (
              <Alert severity="info" sx={{ mb: 2 }}>
                One or more selected instances are currently processing.
                Actions will be enabled once all instances are in <strong>Running</strong> or <strong>Stopped</strong> state.
              </Alert>
            )}

            <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
  {/* --- SINGLE INSTANCE ACTIONS --- */}
  {isSingle && !hasProcessing && singleState === "running" && (
    <>
     
<RoleGuard requiredPermission="START_STOP">    
    <Button
        variant="outlined"
        color="error"
        disabled={actionLoading}
        onClick={() => {
          setScheduleAction("stop");
          setScheduleDialogOpen(true);
        }}
      >
        Schedule Stop
      </Button>
      <Button
        variant="contained"
        color="error"
        disabled={actionLoading}
        onClick={() => {
          setPendingAction("stop");
          setConfirmDialogOpen(true);
        }}
      >
        Stop
      </Button>
      </RoleGuard>
    </>
    
  )}

  {isSingle && !hasProcessing && singleState === "stopped" && (
    <>
    <RoleGuard requiredPermission="START_STOP">    
      <Button
        variant="outlined"
        color="primary"
        disabled={actionLoading}
        onClick={() => {
          setScheduleAction("start");
          setScheduleDialogOpen(true);
        }}
      >
        Schedule Start
      </Button>
      <Button
        variant="contained"
        color="primary"
        disabled={actionLoading}
        onClick={() => {
          setPendingAction("start");
          setConfirmDialogOpen(true);
        }}
      >
        Start
      </Button>
       </RoleGuard>
    </>
  )}

  {/* --- BULK ACTIONS (MULTIPLE INSTANCES) --- */}
  {isMultiple && (
    <>
    

<RoleGuard requiredPermission="BULK_START_STOP">    
      {/* Start Actions */}
      <Button
        variant="outlined"
        color="primary"
        disabled={actionLoading || hasProcessing || allRunning}
        onClick={() => {
          setScheduleAction("start");
          setScheduleDialogOpen(true);
        }}
      >
        Schedule Start
      </Button>
      <Button
        variant="contained"
        color="primary"
        disabled={actionLoading || hasProcessing || allRunning}
        onClick={() => {
          setPendingAction("start");
          setConfirmDialogOpen(true);
        }}
      >
        Start
      </Button>

      {/* Stop Actions */}
      <Button
        variant="outlined"
        color="error"
        disabled={actionLoading || hasProcessing || allStopped}
        onClick={() => {
          setScheduleAction("stop");
          setScheduleDialogOpen(true);
        }}
      >
        Schedule Stop
      </Button>
      <Button
        variant="contained"
        color="error"
        disabled={actionLoading || hasProcessing || allStopped}
        onClick={() => {
          setPendingAction("stop");
          setConfirmDialogOpen(true);
        }}
      >
        Stop
      </Button>
      </RoleGuard>
    </>
  )}
</Box>
          </DialogActions>


        </Dialog>
       <Dialog 
          open={confirmDialogOpen} 
          onClose={() => {
            if (!actionLoading) setConfirmDialogOpen(false);
          }}
        >
          <DialogTitle sx={{ fontSize: '18px', fontWeight: 'Bold' }}>Confirm Action</DialogTitle>
          <DialogContent>
            <Typography>
              Are you sure you want to {pendingAction}{" "}
              {currentInstanceStates.length > 1 ? "these instances" : "this instance"}?
            </Typography>
          </DialogContent>

          <DialogActions>
            <Button 
              onClick={() => setConfirmDialogOpen(false)}
              disabled={actionLoading} 
            >
              Cancel
            </Button>

            <Button
  color="primary"
  variant="contained"
  disabled={actionLoading}
  onClick={() => {
    setConfirmDialogOpen(false); // 1. Close the popup instantly
    handleExecuteAction(pendingAction); // 2. Fire the API call in the background
  }}
>
  {actionLoading ? "Processing..." : `Yes, ${pendingAction}`}
</Button>
          </DialogActions>
        </Dialog>

      </Box>
    </Layout>
  );
};

export default Resource;
